import { render } from "./Spinner.vue?vue&type=template&id=453983b6&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=453983b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453983b6"]])

export default __exports__